/**
 * @typedef {import('../shared/index.d.ts').ConsentData} ConsentData
 * @typedef {'analysis'| 'marketing'} GoogleAnalyticsConsentType
 */
/* eslint-disable class-methods-use-this */
export class GoogleAnalytics {
  /**
   *
   * @type {GoogleAnalytics}
   */
  static #instance;

  /**
     *
     * @type {GoogleAnalytics}
     */
  static #consentType;

  #isInitialized = false;

  /**
   *
   * @param {string} id
   * @param {GoogleAnalyticsConsentType} consentType
   * @returns {GoogleAnalytics}
   */
  constructor(id, consentType) {
    if (!GoogleAnalytics.instance) {
      this.#init(id);
      GoogleAnalytics.instance = this;
      GoogleAnalytics.consentType = consentType;
    }

    // eslint-disable-next-line no-constructor-return
    return GoogleAnalytics.instance;
  }

  /**
   * @param {string} page
   */
  pushCurrentPage(page) {
    window.dataLayer.push({
      event: 'GAevent',
      eventAction: page,
      eventCategory: 'portal-dodo',
      eventLabel: `Page_${page}`,
    });
  }

  /**
   *
   * @param {string} id
   */
  #init(id) {
    window.dataLayer = [];

    window.dodo.consent.addListener((consents) => {
      if (consents[GoogleAnalytics.consentType] && !this.isInitialized) {
        this.constructor.createScriptTag(id);
        this.constructor.createNoScriptTag(id);

        this.isInitialized = true;

        window.dataLayer.push({ event: 'bosch_privacy_update_marketing_on' });
      }

      if (!consents[GoogleAnalytics.consentType] && this.isInitialized) {
        window.location.reload();
      }
    });
  }

  static createScriptTag(id) {
    /* eslint-disable */
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0], j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', id);
    /* eslint-enable **/
  }

  static createNoScriptTag(id) {
    const ns = document.createElement('noscript');
    ns.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden" sandbox=""></iframe>`;
    document.head.appendChild(ns);
  }
}
